
import { Notification } from 'element-ui';

import pcormove from './pcormove'

import { Toast } from 'vant';




const ismessage = (type, msg) => {
    if (pcormove._isMobile() == 'app') {
        if (type == 'success') {
            Toast(msg);
        } else {
            Toast(msg);
        }
    } else {

        Notification.closeAll();
        if(type == 'success'){
            Notification({
                message: msg,
                type: 'success',
                showClose: false,
                duration:3000,
                customClass:'succ_notify'
            })
        }else if(type == 'error'){
            Notification({
                message: msg,
                type: 'error',
                showClose: false,
                duration:3000,
                customClass:'err_notify'
            })
        }else{
            Notification({
                message: msg,
                type: 'info',
                showClose: false,
                // duration:0 0是 不自动关闭
                duration:3000
            })
        }
        
    }
}

export default {
    ismessage
}